var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 372,
    viewBox: "0 0 487 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3841_12221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.201,
    y: 139.537,
    width: 79.571,
    height: 70.4024,
    rx: 6.54906,
    fill: "#53CD60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3841_12221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.979,
    cy: 175.055,
    r: 135.357,
    stroke: "#5CDF6A",
    strokeOpacity: 0.1,
    strokeWidth: 74.5678,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3841_12221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.973,
    cy: 175.054,
    r: 117.58,
    stroke: "#5CDF6A",
    strokeOpacity: 0.3,
    strokeWidth: 23.445,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3841_12221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.975,
    cy: 175.062,
    r: 105.858,
    fill: "url(#paint0_linear_3841_12221)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.975,
    cy: 175.062,
    r: 90.9383,
    stroke: "#5CDF6A",
    strokeOpacity: 0.65,
    strokeWidth: 29.8391,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3841_12221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.983,
    cy: 175.057,
    r: 58.6891,
    stroke: "#53CD60",
    strokeOpacity: 0.45,
    strokeWidth: 1.97829,
    strokeLinecap: "round",
    strokeDasharray: "8.24 8.24",
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3841_12221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.983,
    cy: 175.056,
    r: 39.0751,
    fill: "#357453"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.182 126.023C171.526 127.002 170.215 128.471 169.429 130.227L139.887 196.279C137.789 200.969 139.897 206.471 144.591 208.558L183.677 225.94C188.305 227.999 193.729 225.969 195.87 221.379L226.711 155.24C227.473 153.607 227.743 151.788 227.488 150.004L224.4 128.338C223.925 125.004 221.683 122.189 218.54 120.979L200.424 114.011C197.775 112.992 194.805 113.24 192.362 114.684L173.182 126.023ZM206.51 147.185C212.321 143.749 214.246 136.254 210.811 130.443C207.376 124.632 199.88 122.706 194.069 126.142C188.258 129.577 186.333 137.073 189.768 142.883C193.203 148.694 200.699 150.62 206.51 147.185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.284 130.932C220.392 138.054 232.344 110.158 215.754 95.4591C195.415 77.4388 174.823 100.693 182.574 114.779",
    stroke: "#E2B93B",
    strokeWidth: 10.1627,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.812 207.098C352.377 207.098 347.485 206.438 343.136 205.118C338.788 203.72 334.633 201.313 330.673 197.896C329.664 197.042 328.887 196.071 328.344 194.984C327.8 193.897 327.528 192.81 327.528 191.723C327.528 189.937 328.149 188.384 329.392 187.064C330.712 185.666 332.343 184.967 334.284 184.967C335.759 184.967 337.079 185.433 338.244 186.365C341.195 188.772 344.107 190.597 346.98 191.839C349.931 193.082 353.541 193.703 357.812 193.703C360.685 193.703 363.325 193.276 365.733 192.422C368.14 191.49 370.081 190.286 371.557 188.811C373.032 187.258 373.77 185.511 373.77 183.569C373.77 181.24 373.071 179.26 371.673 177.629C370.275 175.998 368.14 174.639 365.267 173.552C362.394 172.388 358.744 171.495 354.318 170.873C350.125 170.252 346.436 169.32 343.253 168.078C340.069 166.758 337.39 165.127 335.216 163.186C333.119 161.167 331.527 158.837 330.44 156.197C329.353 153.48 328.809 150.451 328.809 147.112C328.809 142.065 330.091 137.755 332.653 134.183C335.293 130.611 338.826 127.893 343.253 126.03C347.679 124.166 352.571 123.234 357.929 123.234C362.976 123.234 367.635 124.011 371.906 125.564C376.254 127.039 379.788 128.942 382.505 131.271C384.757 133.057 385.883 135.115 385.883 137.445C385.883 139.153 385.223 140.706 383.903 142.104C382.583 143.501 381.03 144.2 379.244 144.2C378.079 144.2 377.031 143.851 376.099 143.152C374.857 142.065 373.187 141.055 371.091 140.123C368.994 139.114 366.781 138.299 364.451 137.677C362.122 136.979 359.948 136.629 357.929 136.629C354.59 136.629 351.755 137.056 349.426 137.91C347.174 138.765 345.466 139.929 344.301 141.405C343.136 142.88 342.554 144.588 342.554 146.53C342.554 148.859 343.214 150.801 344.534 152.354C345.932 153.829 347.912 155.033 350.474 155.964C353.037 156.819 356.104 157.595 359.676 158.294C364.335 159.148 368.412 160.158 371.906 161.322C375.478 162.487 378.429 164.001 380.758 165.865C383.088 167.651 384.835 169.942 386 172.737C387.164 175.455 387.747 178.794 387.747 182.754C387.747 187.801 386.349 192.15 383.554 195.799C380.758 199.449 377.07 202.245 372.488 204.186C367.985 206.127 363.093 207.098 357.812 207.098ZM366.199 213.387C366.199 215.406 365.5 217.076 364.102 218.396C362.782 219.794 361.112 220.493 359.093 220.493C357.152 220.493 355.522 219.794 354.201 218.396C352.881 217.076 352.221 215.406 352.221 213.387V119.74C352.221 117.721 352.881 116.052 354.201 114.731C355.599 113.334 357.307 112.635 359.326 112.635C361.345 112.635 362.976 113.334 364.218 114.731C365.539 116.052 366.199 117.721 366.199 119.74V213.387Z",
    fill: "#E2B93B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2842 335.076C18.0229 335.076 15.0876 334.68 12.4786 333.888C9.86947 333.049 7.37686 331.605 5.00073 329.555C4.39505 329.042 3.92915 328.46 3.60301 327.807C3.27687 327.155 3.11381 326.503 3.11381 325.851C3.11381 324.779 3.48653 323.847 4.23199 323.055C5.02403 322.217 6.00244 321.797 7.16721 321.797C8.05243 321.797 8.84447 322.077 9.54334 322.636C11.3138 324.08 13.0609 325.175 14.7848 325.921C16.5553 326.666 18.7217 327.039 21.2842 327.039C23.0081 327.039 24.5922 326.783 26.0365 326.27C27.4808 325.711 28.6456 324.989 29.5308 324.104C30.416 323.172 30.8586 322.123 30.8586 320.959C30.8586 319.561 30.4393 318.373 29.6007 317.394C28.762 316.416 27.4808 315.601 25.7569 314.948C24.0331 314.25 21.8433 313.714 19.1876 313.341C16.6717 312.968 14.4587 312.409 12.5484 311.664C10.6382 310.872 9.03084 309.893 7.7263 308.729C6.46834 307.517 5.51323 306.119 4.86096 304.535C4.20869 302.905 3.88255 301.088 3.88255 299.084C3.88255 296.056 4.6513 293.47 6.1888 291.327C7.77289 289.184 9.89277 287.553 12.5484 286.435C15.2041 285.317 18.1393 284.758 21.3541 284.758C24.3825 284.758 27.178 285.224 29.7404 286.155C32.3495 287.041 34.4694 288.182 36.1001 289.58C37.4512 290.651 38.1268 291.886 38.1268 293.284C38.1268 294.309 37.7308 295.241 36.9387 296.079C36.1467 296.918 35.2149 297.337 34.1433 297.337C33.4444 297.337 32.8154 297.127 32.2563 296.708C31.5109 296.056 30.5092 295.45 29.2512 294.891C27.9933 294.285 26.6655 293.796 25.2677 293.423C23.87 293.004 22.5655 292.795 21.3541 292.795C19.3507 292.795 17.6501 293.051 16.2524 293.563C14.9013 294.076 13.8763 294.775 13.1774 295.66C12.4786 296.545 12.1291 297.57 12.1291 298.735C12.1291 300.133 12.5251 301.297 13.3172 302.229C14.1558 303.114 15.3439 303.837 16.8814 304.396C18.4189 304.908 20.2592 305.374 22.4024 305.793C25.1978 306.306 27.6439 306.912 29.7404 307.61C31.8836 308.309 33.6541 309.218 35.0518 310.336C36.4495 311.408 37.4978 312.782 38.1967 314.459C38.8955 316.09 39.245 318.093 39.245 320.469C39.245 323.498 38.4063 326.107 36.7291 328.297C35.0518 330.486 32.8387 332.164 30.0899 333.329C27.3876 334.493 24.4524 335.076 21.2842 335.076ZM26.316 338.85C26.316 340.061 25.8967 341.063 25.0581 341.855C24.266 342.693 23.2643 343.113 22.053 343.113C20.8882 343.113 19.9098 342.693 19.1177 341.855C18.3257 341.063 17.9297 340.061 17.9297 338.85V282.661C17.9297 281.45 18.3257 280.448 19.1177 279.656C19.9564 278.817 20.9814 278.398 22.1927 278.398C23.4041 278.398 24.3825 278.817 25.128 279.656C25.92 280.448 26.316 281.45 26.316 282.661V338.85Z",
    fill: "#E2B93B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6954 76.5905C47.5675 76.5905 45.6523 76.3321 43.9499 75.8153C42.2475 75.2681 40.6212 74.3257 39.0708 72.9882C38.6756 72.6538 38.3716 72.2738 38.1588 71.8482C37.946 71.4226 37.8396 70.997 37.8396 70.5714C37.8396 69.8722 38.0828 69.2642 38.5692 68.7474C39.086 68.2002 39.7244 67.9266 40.4844 67.9266C41.0619 67.9266 41.5787 68.109 42.0347 68.4738C43.1899 69.4162 44.3299 70.1306 45.4547 70.617C46.6099 71.1034 48.0234 71.3466 49.6954 71.3466C50.8202 71.3466 51.8538 71.1794 52.7962 70.845C53.7386 70.4802 54.4985 70.009 55.0761 69.4314C55.6537 68.8234 55.9425 68.1394 55.9425 67.3794C55.9425 66.4675 55.6689 65.6923 55.1217 65.0539C54.5745 64.4155 53.7386 63.8835 52.6138 63.4579C51.489 63.0019 50.0602 62.6523 48.3274 62.4091C46.6859 62.1659 45.2419 61.8011 43.9955 61.3147C42.7491 60.7979 41.7003 60.1595 40.8492 59.3996C40.0284 58.6092 39.4052 57.6972 38.9796 56.6636C38.554 55.5996 38.3412 54.414 38.3412 53.1069C38.3412 51.1309 38.8428 49.4437 39.846 48.0453C40.8796 46.647 42.2627 45.583 43.9955 44.8534C45.7283 44.1238 47.6434 43.759 49.741 43.759C51.717 43.759 53.541 44.063 55.2129 44.671C56.9153 45.2486 58.2985 45.9934 59.3625 46.9053C60.2441 47.6045 60.6849 48.4101 60.6849 49.3221C60.6849 49.9909 60.4265 50.5989 59.9097 51.1461C59.3929 51.6933 58.7849 51.9669 58.0857 51.9669C57.6297 51.9669 57.2193 51.8301 56.8545 51.5565C56.3681 51.1309 55.7145 50.7357 54.8937 50.3709C54.073 49.9757 53.2066 49.6565 52.2946 49.4133C51.3826 49.1397 50.5314 49.0029 49.741 49.0029C48.4338 49.0029 47.3243 49.1701 46.4123 49.5045C45.5307 49.8389 44.8619 50.2949 44.4059 50.8725C43.9499 51.4501 43.7219 52.1189 43.7219 52.8789C43.7219 53.7908 43.9803 54.5508 44.4971 55.1588C45.0443 55.7364 45.8195 56.2076 46.8227 56.5724C47.8258 56.9068 49.0266 57.2108 50.425 57.4844C52.249 57.8188 53.845 58.214 55.2129 58.67C56.6113 59.126 57.7665 59.7188 58.6785 60.4483C59.5905 61.1475 60.2745 62.0443 60.7305 63.1387C61.1864 64.2027 61.4144 65.5099 61.4144 67.0602C61.4144 69.0362 60.8672 70.7386 59.7729 72.1674C58.6785 73.5961 57.2345 74.6905 55.4409 75.4505C53.6778 76.2105 51.7626 76.5905 49.6954 76.5905ZM52.9786 79.0529C52.9786 79.8433 52.705 80.4968 52.1578 81.0136C51.641 81.5608 50.9874 81.8344 50.197 81.8344C49.437 81.8344 48.7986 81.5608 48.2818 81.0136C47.765 80.4968 47.5067 79.8433 47.5067 79.0529V42.391C47.5067 41.6006 47.765 40.947 48.2818 40.4302C48.829 39.8831 49.4978 39.6095 50.2882 39.6095C51.0786 39.6095 51.717 39.8831 52.2034 40.4302C52.7202 40.947 52.9786 41.6006 52.9786 42.391V79.0529Z",
    fill: "#E2B93B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.412 328.705C307.394 328.705 306.479 328.582 305.665 328.335C304.851 328.073 304.073 327.622 303.332 326.983C303.143 326.823 302.998 326.641 302.896 326.438C302.794 326.234 302.743 326.031 302.743 325.827C302.743 325.493 302.859 325.202 303.092 324.955C303.339 324.694 303.644 324.563 304.008 324.563C304.284 324.563 304.531 324.65 304.749 324.825C305.301 325.275 305.846 325.617 306.384 325.849C306.936 326.082 307.612 326.198 308.412 326.198C308.95 326.198 309.444 326.118 309.894 325.958C310.345 325.784 310.708 325.559 310.984 325.282C311.261 324.992 311.399 324.665 311.399 324.301C311.399 323.865 311.268 323.495 311.006 323.189C310.745 322.884 310.345 322.63 309.807 322.426C309.269 322.208 308.586 322.041 307.758 321.925C306.973 321.809 306.282 321.634 305.686 321.402C305.091 321.155 304.589 320.849 304.182 320.486C303.79 320.108 303.492 319.672 303.288 319.178C303.085 318.669 302.983 318.102 302.983 317.477C302.983 316.532 303.223 315.726 303.702 315.057C304.197 314.389 304.858 313.88 305.686 313.531C306.515 313.182 307.431 313.008 308.434 313.008C309.378 313.008 310.25 313.153 311.05 313.444C311.864 313.72 312.525 314.076 313.034 314.512C313.455 314.846 313.666 315.232 313.666 315.668C313.666 315.987 313.542 316.278 313.295 316.54C313.048 316.801 312.758 316.932 312.423 316.932C312.205 316.932 312.009 316.867 311.835 316.736C311.602 316.532 311.29 316.344 310.897 316.169C310.505 315.98 310.09 315.828 309.654 315.711C309.218 315.58 308.811 315.515 308.434 315.515C307.809 315.515 307.278 315.595 306.842 315.755C306.42 315.915 306.101 316.133 305.883 316.409C305.665 316.685 305.556 317.005 305.556 317.368C305.556 317.804 305.679 318.168 305.926 318.458C306.188 318.734 306.559 318.96 307.038 319.134C307.518 319.294 308.092 319.439 308.761 319.57C309.633 319.73 310.396 319.919 311.05 320.137C311.718 320.355 312.271 320.639 312.707 320.987C313.143 321.322 313.47 321.75 313.688 322.274C313.906 322.782 314.015 323.407 314.015 324.149C314.015 325.093 313.753 325.907 313.23 326.591C312.707 327.274 312.016 327.797 311.159 328.16C310.316 328.524 309.4 328.705 308.412 328.705ZM309.981 329.883C309.981 330.261 309.851 330.573 309.589 330.82C309.342 331.082 309.029 331.213 308.652 331.213C308.288 331.213 307.983 331.082 307.736 330.82C307.489 330.573 307.365 330.261 307.365 329.883V312.354C307.365 311.976 307.489 311.663 307.736 311.416C307.997 311.155 308.317 311.024 308.695 311.024C309.073 311.024 309.378 311.155 309.611 311.416C309.858 311.663 309.981 311.976 309.981 312.354V329.883Z",
    fill: "#E2B93B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3841_12221",
    x: 28.976,
    y: 22.3118,
    width: 314.021,
    height: 304.853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.6126,
    result: "effect1_foregroundBlur_3841_12221"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3841_12221",
    x: 11.0049,
    y: 0.0816598,
    width: 349.947,
    height: 349.947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16649,
    result: "effect1_foregroundBlur_3841_12221"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3841_12221",
    x: 35.6731,
    y: 24.7546,
    width: 300.599,
    height: 300.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4984
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3841_12221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3841_12221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3841_12221",
    x: 50.9549,
    y: 40.0423,
    width: 270.039,
    height: 270.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3841_12221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3841_12221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3841_12221",
    x: 111.14,
    y: 102.548,
    width: 149.686,
    height: 149.685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.33298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.58219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3841_12221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3841_12221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3841_12221",
    x: 110.747,
    y: 99.8195,
    width: 150.473,
    height: 150.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.0806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3841_12221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3841_12221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3841_12221",
    x1: 128.818,
    y1: 82.9086,
    x2: 296.501,
    y2: 247.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203D77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingNew);
export default __webpack_public_path__ + "static/media/pricing-new.a1619fa032e61f96016e91d24b356cf7.svg";
export { ForwardRef as ReactComponent };